import React, { useState } from "react";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useHistory, useNavigate } from "react-router-dom";
import SpeedIcon from "@mui/icons-material/Speed";
import GroupIcon from "@mui/icons-material/Group";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { BookCheck, Calendar1, CircleUserRound } from "lucide-react";

const BottomNavigationComponent = () => {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();

  const storedRole = localStorage.getItem('empRole');

  // Handle navigation based on the selected bottom nav item
  const handleChange = (event, newValue) => {
    setValue(newValue);
    switch (newValue) {
      case 0:
        navigate("/dashboard"); // Navigate to Home page
        break;
      case 1:
        (storedRole === "2") ? navigate("/bdmAssigned") : ((storedRole === "1" || storedRole === "3") ? navigate("/lead") : navigate("/leadMaster")); // Navigate to Search page
        break;
      case 2:
        navigate("/bdmtodo"); // Navigate to Notifications page
        break;
      case 3:
        storedRole === "5" ? navigate('/attendanceReport') : navigate("/attendanceReport/details"); // Navigate to Profile page
        break;
      case 4:
        navigate("/leaveReport"); // Navigate to Profile page
        break;
      default:
        break;
    }
  };

  return (
    <BottomNavigation
      value={value}
      onChange={handleChange}
      showLabels  
      sx={{
        width: "100%",
        position: "fixed",
        bottom: 0,
        left: 0,
        zIndex: 1000,
        gap: '0px',
        backgroundColor: "white", // Or use theme palette
        boxShadow: "0px -4px 6px rgba(0, 0, 0, 0.1)", // Adds some shadow to lift the bottom bar,
        marginTop: "10px"
      }}
    >
      <BottomNavigationAction label="Dashboard" icon={<SpeedIcon />} sx={{
          textAlign: "center", // Align text in the center of each button,
          paddingLeft: '35px'
        }} />
      {storedRole !== "500" && (<BottomNavigationAction label="Leads" icon={<GroupIcon />} sx={{
          textAlign: "center", // Align text in the center of each button
        }}/>)}
      {(storedRole === "2" || storedRole === "3" || storedRole === "500") && (<BottomNavigationAction label="Task" icon={<BookCheck />} sx={{
          textAlign: "center", // Align text in the center of each button
        }}/>)}
      { (<BottomNavigationAction label="Travel" icon={<Calendar1 />} sx={{
          textAlign: "center", // Align text in the center of each button
        }}/>)}
      {storedRole !== "500" && (<BottomNavigationAction label="Leave" icon={<CircleUserRound />} sx={{
          textAlign: "center", // Align text in the center of each button
          paddingRight: '30px'
        }}/>)}
    </BottomNavigation>
  );
};

export default BottomNavigationComponent;
